import axios from "axios";

const api = axios.create({
  // Agora usa a variável de ambiente
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Função login
export const login = (usernameOrEmail, password) =>
  api.post("/login", { usernameOrEmail, password });

// Função registro
export const register = (username, email, password) =>
  api.post("/register", { username, email, password });

// Função "esqueci minha senha"
export const forgotPassword = (email) =>
  api.post("/forgot-password", { email });

// Função redefinir senha
export const resetPassword = (email, code, newPassword) =>
  api.post("/reset-password", { email, code, newPassword });

export default api;

